/**
 * Cloudflare Turnstile Configuration
 * Created: 2025-11-08
 * 
 * Public configuration for Turnstile CAPTCHA integration
 */

export const TURNSTILE_CONFIG = {
  siteKey: '0x4AAAAAAB_6pVCpxLaZjAKj', // Public key - safe to commit
  theme: 'light' as const,
  size: 'normal' as const,
  language: 'pl', // Polish language
  appearance: 'always' as const, // Always show the widget
} as const;

export const TURNSTILE_MESSAGES = {
  loading: 'Weryfikacja bezpieczeństwa...',
  error: 'Weryfikacja nie powiodła się. Spróbuj ponownie.',
  retry: 'Spróbuj ponownie',
  verifying: 'Weryfikacja...',
  verified: 'Zweryfikowano pomyślnie',
} as const;
